
import { } from '@angular/common/http';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalInterceptorConfiguration, MsalGuardConfiguration } from '@azure/msal-angular';
import { environment } from '../environments/environment';

export function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log('loggerCallback', message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  // environment.prod.ts resolves redirectUrl from the current hostname, so the
  // App Service "staging" slot gets its own (registered) redirect URI automatically.
  const uri = environment.redirectUrl;

  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      authority: `https://login.microsoftonline.com/${environment.tenantId}`,
      redirectUri: uri.replace(/\/+$/, '') + '/redirect'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(`${environment.redirectUrl}api/*`, [`api://${environment.clientId}/access_as_user`]);
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me/calendarView', ['Calendars.Read']);
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me/drive/recent', ['Files.Read']);
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me/insights/used', ['Sites.Read.All']);
  protectedResourceMap.set('https://api.powerbi.com/v1.0/myorg/*', [
    'https://analysis.windows.net/powerbi/api/Workspace.Read.All',
    'https://analysis.windows.net/powerbi/api/Report.Read.All'
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [`api://${environment.clientId}/access_as_user`]
    },
  };
}

